import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { OverlayBackdrop } from "./OverlayBackdrop";
var propTypes = {
  onClose: PropTypes.func,
  center: PropTypes.bool
};
var defaultProps = {
  onClose: function onClose() {}
};
export function Backdrop(_ref) {
  var onClose = _ref.onClose,
      props = _objectWithoutProperties(_ref, ["onClose"]);

  var backdropRef = React.createRef();
  /* If backdrop is clicked, execute onClose */

  var onClick = function onClick(event) {
    if (event.target === backdropRef.current) {
      onClose(event);
    }
  };
  /* if escape key is pressed, execute onClose */


  var onKeydown = function onKeydown(event) {
    if (event.keyCode === 27) {
      onClose(event);
    }
  };

  useEffect(function () {
    /* add event listener for escape key press */
    window.addEventListener('keydown', onKeydown, true);
    /* clean up */

    return function () {
      window.removeEventListener('keydown', onKeydown, true);
    };
  });
  return React.createElement(OverlayBackdrop, Object.assign({
    ref: backdropRef,
    onClick: onClick
  }, props));
}
Backdrop.propTypes = propTypes;
Backdrop.defaultProps = defaultProps;
export default Backdrop;